<template>
  <bean-source-page
    :type="type"
    :columns="columns"
    :form-columns="formColumns"
    :filter-columns="filterColumns"
    :actions="actions"
    :form="form"
    :title="$t('model.localScenery')"
    resource="local_sceneries"
  />
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { filterColumnsExtend, columnsExtend, formColumnsExtend } from '../admin_grapes/local_sceneries.js';
import _ from 'lodash';

@Component
export default class LocalSceneries extends Vue {
  @Prop(String) type;

  // form 新建表单初始化数据（default数据）
  form = {}

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  filterColumns() {
    const array = [
      'name_cont',
      'jump_page_type_eq',
    ].filter(Boolean)

    return filterColumnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  columns(h, { type }) {
    const array = [
      type === 'show' && 'id',
      type === 'show' && 'stations',
      'name',
      'position',
      'cover',
      'jump_page_type',
      'appid',
      'path',
      'env_version',
      type === 'show' && { key: 'content', renderCell: { component: 'html' } },
      type === 'show' && 'created_at',
      type === 'show' && 'updated_at',
    ].filter(Boolean)

    return columnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource - RESTful api resoure name
   * @param {Object} params.data - current form data
   * @param {Function} params.change - invoke this method to sync form change({ field: 'new value' })
   */
  formColumns(h, { data, type }) {
    const array = [
      {
        prop: 'station_ids',
        label: this.$t('localScenery.stations'),
        renderCell: {
          component: 'select',
          props: {
            clearable: true,
            filterable: true,
            multiple: true,
            options: _.map(data.stations, ({ id, name }) => ({ value: id, label: name })),
            'x-remote': {
              strategy: 'search',
              remoteMethod: async (name_cont) => {
                const { data } = await this.$request.get('stations', { params: { name_cont } })
                return _.map(data, ({ id, name }) => ({ value: id, label: name }))
              }
            }
          }
        }
      },
      'name',
      {
        key: 'position',
        renderCell: {
          hint: this.$t('hint.positionColumn'),
        }
      },
      {
        key: 'cover',
        renderCell: {
          hint: `${this.$t('suggestSize')}: 163x163`,
          props: {
            cropper: {
              width: 163,
              height: 163
            }
          }
        }
      },
      'jump_page_type',
      data.jump_page_type === 'mini_program' && 'appid',
      data.jump_page_type === 'mini_program' && {
        key: 'path',
        renderCell: {
          hint: '例：pages/index/index',
        },
      },
      data.jump_page_type === 'mini_program' && 'env_version',
      data.jump_page_type === 'local' && { key: 'content', renderCell: { component: 'editor' } },
    ].filter(Boolean)

    return formColumnsExtend(array, { data: data, type: type })
  }

  /**
   * @param {Object} scope -页面/表格 scope 数据
   * @param {Object} scope.row - 详情页/表格行 数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
   */
  actions({ row }, { remove }) {
    return [
      {
        component: 'routeButton',
        props: {
          label: this.$t('edit'),
          to: { name: 'local_sceneries.edit', params: { id: row.id } }
        }
      },
      {
        component: 'confirmButton',
        props: {
          label: this.$t('destroy'),
          type: 'danger',
          can: 'local_sceneries.destroy'
        },
        on: {
          confirm: () => remove(row.id)
        }
      }
    ].filter(Boolean);
  }
}

export const route = [
  {
    path: '/local_sceneries',
    name: 'local_sceneries.index',
    component: LocalSceneries,
    props: {
      type: 'index',
    }
  },
  {
    path: '/local_sceneries/new',
    name: 'local_sceneries.new',
    component: LocalSceneries,
    props: {
      type: 'new',
    }
  },
  {
    path: '/local_sceneries/:id',
    name: 'local_sceneries.show',
    component: LocalSceneries,
    props: {
      type: 'show',
    }
  },
  {
    path: '/local_sceneries/:id/edit',
    name: 'local_sceneries.edit',
    component: LocalSceneries,
    props: {
      type: 'edit'
    }
  }
]
</script>
